<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import DownloadPanel from '@/shared/components/DownloadPanel.vue'
import { useUserStoreWithOut } from '@/store/modules/user'

const userStore = useUserStoreWithOut()

/**
 * 跨站点登出同步：任一站点登出后，认证中心会在父域写入 sso_logout 标记。
 * 启动、窗口聚焦、标签页重新可见时检查；命中则清除本地会话并回到登录流程。
 * （标记由后端在下次登录成功时清除，因此不会误伤新会话。）
 */
function syncSsoLogout() {
  if (!/(?:^|;\s*)sso_logout=/.test(document.cookie)) return
  if (!userStore.getToken) return
  if (window.location.pathname === '/sso-callback') return
  userStore.logout()
  window.location.href = '/sso-callback'
}

onMounted(() => {
  syncSsoLogout()
  window.addEventListener('focus', syncSsoLogout)
  document.addEventListener('visibilitychange', syncSsoLogout)
})

onBeforeUnmount(() => {
  window.removeEventListener('focus', syncSsoLogout)
  document.removeEventListener('visibilitychange', syncSsoLogout)
})
</script>

<template>
  <!--
    统一 z-index 起点（默认 2000）。
    项目里各全屏遮罩（图片/视频预览、历史面板、下载面板）原本手写 3000~5000，
    与 Element Plus 的计数器互不相干，导致 toast / MessageBox 被遮罩盖住。
    这里保持默认计数器的同时，把项目内手写层级统一收敛到本层级之下（见各 CSS）。
  -->
  <el-config-provider :z-index="2000">
    <router-view />
    <DownloadPanel />
  </el-config-provider>
</template>
